import React, { useState } from "react";
import { PhoneIcon, ClipboardDocumentIcon, ClipboardDocumentCheckIcon } from "@heroicons/react/20/solid";

/**
 * Props :
 * - nom: string
 * - prenom: string
 * - telephone?: string
 * - label?: string (ex: Client, Acheteur, Intervenant…)
 * - onOpenMessagerie?: function
 */
export default function CardContact({
  nom,
  prenom,
  telephone,
  email,
  label = "Client",
}) {
  const [copied, setCopied] = useState(false);

  function copyEmail() {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  //console.log("CardContact render",nom, prenom, telephone, label);
  return (
    <div className="border-b border-gray-200 bg-white px-4 py-2 sm:px-6 rounded-xl mt-3">
      <div className="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
        {/* Infos contact */}
        <div className="ml-4 mt-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <span className="inline-block h-14 w-14 overflow-hidden rounded-full bg-gray-100">
                <svg
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  className="h-full w-full text-gray-300"
                >
                  <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </span>
            </div>

            <div className="ml-4">
              <h3 className="text-base font-semibold leading-6 text-gray-900">
                {nom} {prenom}
              </h3>
              <span className="badge-acheteur">{label}</span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="ml-4 mt-4 flex-wrap flex flex-shrink-0 gap-2">
          {telephone && (
            <button
              type="button"
              className="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            >
              <PhoneIcon
                aria-hidden="true"
                className="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400"
              />
              <span>{telephone}</span>
            </button>
          )}
          {email && (
            <button
              type="button"
              onClick={copyEmail}
              className="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              title="Copier l'email"
            >
              {copied ? (
                <ClipboardDocumentCheckIcon className="-ml-0.5 mr-1.5 h-5 w-5 text-green-500" />
              ) : (
                <ClipboardDocumentIcon className="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" />
              )}
              <span>{copied ? "Copié !" : email}</span>
            </button>
          )}

           
        </div>
      </div>
    </div>
  );
}